// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { CatalogueProductFragmentDoc } from '../../catalogueProduct.fragment.generated';
import { RelatedProductFragmentDoc } from '../../../../../components/rings/RelatedProducts.generated';
import { ProductCardFragmentDoc } from '../../../../../components/layout/cards/ProductCard.generated';
import { ProductLinkFragmentDoc } from '../../../../../router/fragments/productLink.fragment.generated';
import { EngagementRingLinkFragmentDoc } from '../../../../../router/fragments/engagementRingLink.fragment.generated';
import { JewelleryLinkFragmentDoc } from '../../../../../router/fragments/jewelleryLink.fragment.generated';
import { ReadyToGoRingLinkFragmentDoc } from '../../../../../router/fragments/readyToGoRingLink.fragment.generated';
import { WeddingRingLinkFragmentDoc } from '../../../../../router/fragments/weddingRingLink.fragment.generated';
import { MetalVariationFragmentDoc } from '../../../../../components/rings/MetalVariations.generated';
import { MetalFilterMetalFragmentDoc } from '../fragments/filters/metalFilter.fragment.generated';
import { GetIsLabGrownFragmentDoc } from '../../../../../domain/product/getIsLabGrown.generated';
import { MoneyFragmentDoc } from '../../../fragments/money.fragment.generated';
import { MonolithImageSizeFragmentDoc } from '../../../../../components/useImageProps.generated';
import { ProductGalleryFragmentDoc } from '../../../../../components/layout/gallery/ProductGallery.generated';
import { ThreeSixtyFragmentDoc } from '../../../../../components/layout/three-sixty/ThreeSixty.fragment.generated';
import { CatalogueVideoFragmentDoc } from '../../catalogueVideo.fragment.generated';
import { ProductAnalyticsFragmentDoc } from '../../../../../views/product/composables/analytics/useProductAnalytics.generated';
import { ProductPageMetaFragmentDoc } from '../../../../../views/product/composables/useProductPageMeta.generated';
import { AssetFragmentDoc } from '../../../fragments/asset.fragment.generated';
import { JewelleryDesignStyleLabelFragmentDoc, JewelleryNecklaceProductStyleLabelFragmentDoc, JewelleryEarringsProductStyleLabelFragmentDoc, JewelleryBraceletProductStyleLabelFragmentDoc, JewelleryRingProductStyleLabelFragmentDoc } from '../../../../../views/product/jewellery/Jewelleries.generated';
import { FacetedContentProductLabelTranslationFragmentDoc } from '../../../../../domain/product/useFacetedContent.generated';
import { TaxSnippetFragmentDoc } from '../../../../../components/rings/TaxSnippet.generated';
import { DeliveryTimeframeFragmentDoc } from '../../../../../components/rings/DeliveryTimeframe.generated';
import { RingSizeFragmentDoc } from '../fragments/ringSize.fragment.generated';
import { RecommendedRingSizeFragmentDoc } from '../fragments/recommendedRingSize.fragment.generated';
export const JewelleryFragmentDoc = `
    fragment jewellery on CatalogueJewellery {
  ...catalogueProduct
  ...productGallery
  ...productAnalytics
  ...productPageMeta
  engravingDisabled
  designStyles {
    ...jewelleryDesignStyleLabel
  }
  gemstones {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  salePrice(country: $country, currency: $currency) {
    total {
      ...money
    }
    ...taxSnippet
  }
  ... on CatalogueJewelleryNecklace {
    translation(locale: $locale) {
      description
      seoText
    }
    necklaceProductStyles: productStyles {
      ...jewelleryNecklaceProductStyleLabel
    }
    firstAvailableDeliveryDateHasEngraving: firstAvailableDeliveryDate(
      country: $country
      hasEngraving: true
    ) {
      ...deliveryTimeframe
    }
    firstAvailableDeliveryDate(country: $country, hasEngraving: false) {
      ...deliveryTimeframe
    }
    variations {
      ...metalVariation
      ...jewelleryLink
    }
  }
  ... on CatalogueJewelleryEarrings {
    translation(locale: $locale) {
      description
      seoText
    }
    earringsProductStyles: productStyles {
      ...jewelleryEarringsProductStyleLabel
    }
    firstAvailableDeliveryDateHasEngraving: firstAvailableDeliveryDate(
      country: $country
      hasEngraving: true
    ) {
      ...deliveryTimeframe
    }
    firstAvailableDeliveryDate(country: $country, hasEngraving: false) {
      ...deliveryTimeframe
    }
    variations {
      ...metalVariation
      ...jewelleryLink
    }
  }
  ... on CatalogueJewelleryBracelet {
    translation(locale: $locale) {
      description
      seoText
    }
    braceletProductStyles: productStyles {
      ...jewelleryBraceletProductStyleLabel
    }
    firstAvailableDeliveryDateHasEngraving: firstAvailableDeliveryDate(
      country: $country
      hasEngraving: true
    ) {
      ...deliveryTimeframe
    }
    firstAvailableDeliveryDate(country: $country, hasEngraving: false) {
      ...deliveryTimeframe
    }
    variations {
      ...metalVariation
      ...jewelleryLink
    }
  }
  ... on CatalogueJewelleryRing {
    translation(locale: $locale) {
      description
      seoText
    }
    jewelleryRingProductStyles: productStyles {
      ...jewelleryRingProductStyleLabel
    }
    firstAvailableDeliveryDateHasEngraving: firstAvailableDeliveryDate(
      country: $country
      hasEngraving: true
    ) {
      ...deliveryTimeframe
    }
    firstAvailableDeliveryDate(country: $country, hasEngraving: false) {
      ...deliveryTimeframe
    }
    variations {
      ...metalVariation
      ...jewelleryLink
    }
    sizes(country: $country) {
      ... on RingSize {
        ...ringSize
      }
      ... on RecommendedRingSize {
        ...recommendedRingSize
      }
    }
  }
}
    `;